/** @type {number} 最後に生成したマーカー id */
let lastId = 0

export default class Marker {
	/**
	 * マーカーを生成
	 * @param {number} id マーカー id
	 * @param {number} time 時刻
	 * @param {number} frequency 周波数
	 * @param {boolean} usePoint 打点あり
	 * @param {?string} text 内容
	 */
	constructor (id, time, frequency, usePoint = true, text = null) {
		/** @type {number} id */
		this.id = id

		/** @type {number} 時刻 */
		this.time = time

		/** @type {number} 周波数 */
		this.frequency = frequency

		/** @type {boolean} 打点あり */
		this.usePoint = usePoint

		/** @type {string} 内容 */
		this.text = text
	}

	/**
	 * 新規マーカーを生成する。id を自動で割り振る
	 * @param {number} time 時刻
	 * @param {number} frequency 周波数
	 * @param {boolean} usePoint 打点あり
	 * @param {?string} text 内容
	 * @returns {Marker}
	 */
	static create (time, frequency, usePoint = true, text = null) {
		const id = ++lastId
		return new Marker(id, time, frequency, usePoint, text)
	}
}
